import { styled } from "@mui/system";

import { CONTAINER_PADDING_VERTICAL } from "../theme";

export const MainPageContainer = styled("div")`
  padding-top: ${CONTAINER_PADDING_VERTICAL}px;
  padding-bottom: ${CONTAINER_PADDING_VERTICAL}px;
`;
